/**
 * ShareCard
 * Paylaşılabilir final kart
 */

import React from 'react';
import { Share2 } from 'lucide-react';

export default function ShareCard({ 
  oracleName, 
  hiddenMessage, 
  signatureSentence,
  onShare 
}) {
  // Rastgele signature sentence seç
  const signature = Array.isArray(signatureSentence) 
    ? signatureSentence[Math.floor(Math.random() * signatureSentence.length)]
    : signatureSentence;
  
  const handleShare = async () => {
    const shareText = `🔮 ${oracleName}\n\n"${hiddenMessage || signature}"\n\n— MysticAI Oracle`;
    
    if (navigator.share) {
      try {
        await navigator.share({
          title: `MysticAI Oracle - ${oracleName}`,
          text: shareText
        });
      } catch (err) {
        // User cancelled or error
        console.log('Share cancelled');
      }
    } else {
      // Fallback: copy to clipboard
      try {
        await navigator.clipboard.writeText(shareText);
        onShare?.('copied');
      } catch (err) {
        console.error('Copy failed');
      }
    }
  };
  
  return (
    <div className="oracle-glass-card oracle-share-card">
      {oracleName && (
        <div className="oracle-share-title">
          ✨ {oracleName}
        </div>
      )}
      
      <div className="oracle-share-message">
        &ldquo;{hiddenMessage || signature}&rdquo;
      </div>
      
      <button 
        className="oracle-btn-primary oracle-share-btn"
        onClick={handleShare}
        data-testid="share-btn"
      >
        <Share2 size={18} style={{ marginRight: 8, display: 'inline' }} />
        Paylaş
      </button>
    </div>
  );
}
